import { ChangelogUpdateType } from 'src/components/History/types';

const RETURNING_BACK_STATUS = 'returningBack';

const hasOwn = (obj: object, key: string): boolean => Object.prototype.hasOwnProperty.call(obj, key);

const isReturningBackStatusChange = (data: NonNullable<ChangelogUpdateType['data']>): boolean => {
    const status = data.STATUS;
    return typeof status === 'object' && status !== null && !Array.isArray(status) && 'new' in status
        ? status.new === RETURNING_BACK_STATUS
        : false;
};

/**
 * Historical core log entries with message `createReturn` may not carry `RMA` in data
 * (the data is just an order diff). Pick a heading that does not render "{{RMA}}" as "undefined".
 */
export const resolveHistoryMessage = (update: ChangelogUpdateType): ChangelogUpdateType => {
    if (update.message !== 'createReturn') {
        return update;
    }
    const data = update.data;
    if (data && hasOwn(data, 'RMA')) {
        return update;
    }
    if (data && isReturningBackStatusChange(data)) {
        return { ...update, message: 'createReturnWithoutRma' };
    }
    return { ...update, message: 'updateOrder' };
};

export default resolveHistoryMessage;
